<template>

  <div>

    <div>

      <template>
        <div>
          <iframe style="width:100%;height:500px" :src="this.url" title="W3Schools Free Online Web Tutorials"></iframe>
        </div>
      </template>
      <div>
        <v-card-actions>
          <v-btn color="primary">Voltar</v-btn>
        </v-card-actions>

      </div>

    </div>
  </div>
</template>

<script>
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
import impressaoService from '../../services/impressaoService';
import impressaoUtilitario from '../../utilitarios/impressao.utilitario';
export default {
  data: () => ({
    autor: ls.get('nomeUsuario'),
    url: '',
    html: '',
    estudante: ls.get('historicoEstudante'),      
    emolumentosGrouped: ls.get('elumentosGrouped'),
    formatter: 0,
    date: null,
    config: null,
    baseUrl: ''
  }),

  computed: {
     loggedUserName () {
      return ls.get('nomeUsuario')
    },
  },
  created() {
    this.config = impressaoUtilitario.getConfig();
    this.getUrlImpressao();
  },

  methods: {
    async getUrlImpressao() {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        console.log(error);
      } finally {
        this.html_pdf()
      }
    },

   formatMoney(value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    // Enviando a maior quantidade de linhas das tabelas (Items, Modo de Pagamento, Resumo de Imposto)

    html_pdf() {
      try {
        this.date = this.correntDate()
      let dados = ``
      let total = 0

      this.estudante.pagamentos.forEach(element => {
            dados += `
                <tr>
                      <td valign="top" style="text-align:justify;font-size:6px;">` + element.produto + `</td>
                      <td valign="top" style="text-align:justify;font-size:6px;">--</td>
                      <td valign="top" style="text-align:justify;font-size:6px;">`+this.estudante.dadosAcademicos.turma_descricao+`</td>
                      <td valign="top" style="text-align:justify;font-size:6px;">--</td>
                      <td valign="top" style="text-align:right;font-size:6px;">`+utilitarios.IntegerToMoneyValueFatura(element.subTotal_linha)+`</td>
                      <td valign="top" style="text-align:justify;font-size:6px;">`+utilitarios.IntegerToMoneyValueFatura(element.subTotal_linha)+`</td>
                      <td valign="top" style="text-align:justify;font-size:6px;" >`+utilitarios.IntegerToMoneyValueFatura(element.subTotal_linha)+`</td>
                      <td valign="top" style="text-align:center;font-size:6px;">` + element.data_ + `</td>
                      <td valign="top" style="text-align:right;font-size:6px;">` + (element.anulado === 1 ? 'Anulado':'Activo') + `</td>

                </tr>`
             total += element.subTotal_linha
       })

      this.html = `
       <html>
<head>
<style>
table, th, td {
  border: 0px solid black;
  border-collapse: collapse;
  font-size: 11px;
}

#rcorners2 {
   border-radius: 25px;
  padding: 10px;
  width: 450px;
  height: 100px;
}
.column {
  float: left;
  width: 70.33%;
  padding: 5px;
}
.footer {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  margin-top:10px;
}
.linha {
    border-bottom: 1px solid black;
    border-color: #808080;
    padding-top:2px
  }
</style>
</head>
<body>

 <table style="border:0px solid black;margin-left:0px;margin-right:auto;width:100%">
    <tr>
        <td>
            <div class="column">
    <span>  <img src="${this.baseUrl}readfile/`+ this.config.logo + `" alt="Snow" style="width:50%; max-width:80px;" /></span>
  </div>
        </td>
         <td> 
          <strong style=" font-size:12px;">`+ this.config.descricao + `</strong>
        </td>
         
    </tr>
       </table>
      
        
         <div style="text-align:center;"><strong style=" font-size:10px"> EXTRATO TOTAL DE MENSALIDADES </strong> </div>
          <div id="rcorners2">
          <table border="0">
            <tr style="align:center;">
              <td>
                <span style="font-size:8px;font-weight:bold;">ALUNO:</span><span style="font-size:9px">`+this.estudante.dadosAcademicos.nome+`</span></br>
                <span style="font-size:8px;font-weight:bold;">CURSO:</span><span style="font-size:9px">`+this.estudante.dadosAcademicos.curso_descricao+`</span><br>
                <span style="font-size:8px;font-weight:bold;">TURMA:</span><span style="font-size:9px">`+this.estudante.dadosAcademicos.turma_descricao+`</span><br>
                <span style="font-size:8px;font-weight:bold;">ANOLECTIVO:</span><span style="font-size:9px">`+this.estudante.dadosAcademicos.ano_lectivo+`</span><br>
              </td>
              <td>
                <span style="font-size:8px;margin-left:180px;font-weight:bold;">DEPARTAMENTO:</span></br>
                 <span style="font-size:8px;margin-left:180px;font-weight:bold;">VENCIMENTO:</span></br>
              </td>
            </tr>              
          </table>

          <table style="width:100%;margin-top:-8px;">
       <tr>
        <td>
          <div style="border:1px solid black;width:100px;height:90px;margin-left:376px;">
              <v-img style="width:100px;height:90px" src="" aspect-ratio="1.7"></v-img>
          </div>
      </td>
        </tr>
        </table>
          </div>
        </div>
<table style="width:100%;margin-top:30px">
  <tr style="border-bottom:1px solid #ccc;">
      <th  style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">Parc.</th>
      <th  style="text-align:justify;font-size:8px;padding-top:10px;padding-bottom:10px;important">Venc.</th>
      <th  style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size:8px">Turma</th>                      
      <th  style="text-align:center;padding-top:10px;padding-bottom:10px;font-size:8px;">Histórico</th>                     
      <th  style="text-align:right;padding-top:10px;padding-bottom:10px;font-size:8px;">Valor Nominal</th>
      <th  style="text-align:right;padding-top:10px;padding-bottom:10px;font-size:8px;">Valor Corrigido</th>
      <th  style="text-align:right;padding-top:10px;padding-bottom:10px;font-size:8px;">Valor Pago</th>
      <th  style="text-align:right;padding-top:10px;padding-bottom:10px;font-size:8px;">Data Pag.</th>
      <th  style="text-align:right;padding-top:10px;padding-bottom:10px;font-size:8px;">Sit.</th>
  </tr>

  `+ dados + `

<tr style="border-top:1px solid #ccc;">
<td colspan="8" style="text-align:left;padding-top:5px;padding-bottom:3px;font-size: 7px"> TOTAL DO ALUNO:</td>
<td style="font-size:7px;font-weight:bold">`+utilitarios.IntegerToMoneyValueFatura(total)+`</td>
</tr>
<tr style="border-bottom:1px solid #ccc;">
<td colspan="8" style="text-align:left;padding-top:3px;padding-bottom:3px;font-size: 7px">Despesas de Cartório:</td>
<td style="font-size:7px;font-weight:bold">`+utilitarios.IntegerToMoneyValueFatura(0)+`</td>
</tr>
<tr style="border-bottom:1px solid #ccc;">
<td colspan="8" style="text-align:left;padding-top:5px;padding-bottom:5px;font-size: 7px">TOTAL GERAL: </td>
<td style="font-size:7px;font-weight:bold">`+utilitarios.IntegerToMoneyValueFatura(total)+`</td>
</tr>
<tr><td colspan="9" style="text-align:justify;padding-top:5px;font-size: 6px">Dados bancários ISPA:</td></tr>
<tr><td colspan="9" style="text-align:justify;font-size: 6px"><strong>CONTAS BANCÁRIAS</strong>: BIC - 86566883 BIC - 5008895 BFA - 25240037 SOL - 40488690 Millenium - 5004689358 BPC - 0001-G9545451-011 BAI - 52284487</td></tr>
<tr><td colspan="9" style="text-align:justify;font-size: 6px">Standard Bank - I000332845-AOA</td></tr>

</table>

  <table style="border:0px solid black;border-collapse: collapse;width:100%; margin-top:40px">

      <tr>
      <td colspan="4" style="text-align:center">
         <div>__________________________________</div> 
      </td> 
      </tr>
      <tr><td colspan="4" style="text-align:center">`+this.autor+` </td> 
      </tr>
</table>

<div class="footer"> <center style="font-size:8px;margin-top:8px">Luanda, ` + this.date + `</center> </div>
<div style="margin-top:990px">

</body>
</html>`

      let options = {
        'format': 'A4',
        'border': {'right': '12mm', 'left': '12mm'},
        'header': {'height': '15mm'},
        'footer': {'height': '12mm'}
      }

  impressaoService.htmlToPdf(this.html, options);
      } catch (error) {
        console.log(error);
      }
    },
    
    correntDate() {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
    }
  }

}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
